export enum AuthForm {
  Email = "Email",
  CreateAccount = "CreateAccount",
  Login = "Login",
  ResetPassword = "ResetPassword",
  JoinWaitlist = "JoinWaitlist",
  SocialSignUp = "SocialSignUp",
}

export interface AuthModalOptions {
  useSocialLogin?: boolean;
  useDarkMode?: boolean;
}
